/*
 *   File : input.js
 *   Author : https://evoqueinnovativelab.com
 *   Description : Input box
 *   Integrations : null
 *   Version : 1.0.0
 *   Created : 09-12-2021
 */

/*import package*/
import { useState, useEffect } from 'react';

/*import style*/
import styles from '../../styles/components/input.module.scss';

const Input = (props) => {

	const [value, setValue] = useState("");
	const [error, setError] = useState(null);

	useEffect(() => {
		setValue(props.defaultValue);
	}, [props.defaultValue]);

	/* --- validation for email , number (10 digits)----*/
	const validate = () => {
		if (props.type === "email") {
			//eslint-disable-next-line
			if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
				setError("Invalid email")
			}
		}
		
		else if (props.type === "number" && (props.placeholder === "Phone Number" || props.placeholder === "Phone number" || props.placeholder === "Mobile Number")) {
			if (!/^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/.test(value)) {
				setError("Invalid phone")
			}
		}
		if (props.validateLength) {
			if (props.minLength && (value.length < props.minLength)) {
				setError(`Minimum ${props.minLength} charcter${props.minLength > 1 ? "s" : ""} required`);
				props?.valueChange(null);
			}
			else if (value.length > props.maxLength) {
				setError(`Maximum charcter limit(${props.maxLength}) exceeded.`);
				props?.valueChange(null);
			}
		}
		if (props.onlyNumber) {
			if (!/^\d+$/.test(value)) {
				setError("Enter a valid number");
				props?.valueChange(null);
			}
		}
	}

	/* ---- onChange event for inputs and passing value in terms of props ---*/
	const valueChange = (e) => {
		setValue(e.target.value);
		setError(null);

		if (props.is_zero) {
			const newValue = e.target.value.replace(/^0+/, '') || '0';
			if (props.two_decimal) {
				if (newValue.includes(".")) {
					const integerValue = newValue.split(".")[0]
					const decimalValue = newValue.split(".")[1]
					if (decimalValue.length <= 2) {
						props.valueChange(`${integerValue}.${decimalValue}`, e);
					}
				} else {
					props.valueChange(newValue, e);
				}
			} else {
				props.valueChange(newValue, e);
			}
		} else {
			props?.valueChange(e.target.value, e);
		}
	}

	var invalidChars = [
		"-",
		"+",
		"e",
		","
	];

	/* ---- func to be implemented on press of enter ----*/
	const keyPress = (e) => {
		if (props.type === "number") {
			if (invalidChars.includes(e.key)) {
				e.preventDefault();
			}
			if (e.which === 38 || e.which === 40) {
				e.preventDefault();
			}
			if (e.key === ' ' || e.target.selectionStart === 0) {
				e.preventDefault(); // Prevent the space from being entered
			}
			if (e.key === '.' && props.not_decimal) {
				e.preventDefault(); // Prevent the space from being entered
			}
			if (
				e.target.value.length > 0 &&
				e.target.value.startsWith('0') &&
				e.key === '0' &&
				/^0{4}/.test(e.target.value) &&
				props.not_otp !== true
			) {
				e.preventDefault(); // Prevent entering more than 4 leading zeros
			}
		}
		if (e.which === 32 && e.target.selectionStart < 1) {
			e.preventDefault();
		}
		if (e.keyCode === 13) {
			if (props?.onSearch) {
				props?.onSearch();
			}
		}
	}

	return (
		<div className={`${styles.e_input_wrap} position-relative ${props.wrapperClass}`}>
			<input id={props.id}
				value={props.value ?? ""}
				type={props.type}
				checked={props.checked}
				//eslint-disable-next-line
				className={`${styles.e_input_box}` + " " + props.className}
				onChange={(e) => { valueChange(e) }}
				placeholder={props.placeholder}
				required={props.required}
				onBlur={() => { validate() }}
				onFocus={() => setValue(props.value)}
				prefix={props.prefix}
				onKeyDown={e => keyPress(e)}
				name={props.name}
				min={props.min}
				step={props.step}
				readOnly={props.readOnly}
				disabled={props.disabled}
				onWheel={() => document.activeElement.blur()} />


			{
				props.suffix ?
					<span className={`${styles.e_suffix} e-suffix`}>{props.suffix}</span>
					:
					null
			}
			{
				props.preffix ?
					<span className={styles.e_preffix}>{props.preffix}</span>
					:
					null
			}
			{props.label ? <label htmlFor={props.id} className="label">{props.label}</label> : null}
			{/* {
				error ?
					<p className={styles.e_error_msg + " mb-0"}>{error}</p>
					:
					null
			} */}
		</div>
	);
}
export default Input;

